import { styled, Box } from '@staffino/primitive-controls';
import { StyledComponent } from '@emotion/styled';
import React from 'react';

export const HiddenWrapper: StyledComponent<React.ComponentProps<typeof Box>> =
  styled(Box)({
    flexDirection: 'row',
    borderRadius: '0.1875rem',
    backgroundColor: '#f1f8ff',
    border: 'solid 1px #d9ecff',
    padding: 10,
  });

export const StyledColumn: StyledComponent<React.ComponentProps<typeof Box>> =
  styled(Box)(() => ({
    flexDirection: 'column' as const,
    flex: 1,
  }));
